import { Component, Input } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { ListOption } from '../types/list-options';

@Component({
  selector: 'gc-custom-list-range-popover',
  templateUrl: './custom-list-range-popover.component.html',
  styleUrls: ['./custom-list-range-popover.component.scss'],
})
export class CustomListRangePopoverComponent {
  @Input() title!: string;
  @Input() subtitle?: string;
  @Input() listOptions!: ListOption[];
  @Input() doneText = 'Done';

  constructor(public popoverGC: PopoverController) {}

  submit() {
    console.log('Submitting:', this.listOptions);
    this.popoverGC.dismiss(this.listOptions, 'act');
  }
}
